function Stat({ value, label, alert = false }) {
  return (
    <div className="dept2-stat">
      <div className={alert ? 'dept2-stat__value dept2-stat__value--alert' : 'dept2-stat__value'}>
        {value ?? '—'}
      </div>
      <div className="dept2-stat__label">{label}</div>
    </div>
  );
}

export default function DepartmentStatStrip({ tools, members, pending }) {
  return (
    <div className="dept2-stat-strip">
      <Stat value={tools} label="Tools" />
      <Stat value={members} label="Members" />
      {/* Red only when something is outstanding; a zero is not an alarm. */}
      <Stat value={pending} label="Pending" alert={pending > 0} />
    </div>
  );
}
